/*
 * @Author: zhu.huijun
 * @Date: 2021-05-08 14:41:18
 * @Last Modified by: zhu.huijun
 * @Last Modified time: 2021-06-23 09:31:17
 */
import { qrySubsPlanDetailBsnl } from '@/services/selectPlan';
import { getRequestData } from '@/utils/portalDscm';
import get from 'lodash/get';

export default {
  namespace: 'selectOffer',
  state: {
    subsPlanGroup: [],
    sameNumberInfo: {},
  },
  effects: {
    *qrySubsPlanDetailBsnl({ payload }, { call, put }) {
      const response = yield call(qrySubsPlanDetailBsnl, payload);
      const { subsPlanDetailDto } = getRequestData(response);
      yield put({
        type: 'save',
        payload: {
          subsPlanGroup: get(subsPlanDetailDto, 'comboUnitDtoList') || [],
        },
      });
      return subsPlanDetailDto || {};
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clearSelectInfo(state) { // 清空selectOffer选中的信息
      return {
        ...state,
        subsPlanGroup: [],
        sameNumberInfo: {},
      };
    },
  },
};
